import Vue from 'vue';
import VueI18n from 'vue-i18n';

import App from './App.vue';
import router from './router';
import store from './store/store';
import { currency } from './filters/filters';
import locales from './utils/translations/index.js';

import './plugins/bootstrap';
import './plugins/notification';
import './plugins/typed';
import './plugins/i18n';

import { getUserLanguage } from './utils/cookiesConfig.js';

Vue.config.productionTip = false;
Vue.filter('currency', currency);

const userlanguage = getUserLanguage();
const i18n = new VueI18n({ locale: userlanguage, messages: locales });

new Vue({
  router,
  store,
  i18n,
	render: h => h(App),
}).$mount('#app');
